import { HttpClient } from '@opallabs/api'

const createSlideRequest = (layout, presentationId) =>
  HttpClient().post(`/api/v1/presentations/${presentationId}/canvas_slides`, {
    layout,
  })

const createSlide =
  ({ layout, presentationId, createSlideBackboneCallback }) =>
  () => {
    createSlideRequest(layout, presentationId)
      .then((response) => createSlideBackboneCallback(response.data.data))
      .catch((err) => {
        throw err
      })
  }

export default createSlide
